import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: 'url(https://cdn.dev.radishfiction.com/featured/collection_image.1ea71803c47b0e303f7675c129f02f06.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    background: 'url(https://cdn.dev.radishfiction.com/featured/collection_image.c8e9819e60e39920116d50d9394c32eb.jpg) 0 0 no-repeat',
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: 36,
  },

  shine: {
    width: '100%',
    height: '100%',
    '&::after': {
      content: '" "',
      top: 0,
      transform: 'translateX(100%)',
      width: '100%',
      height: '100%',
      position: 'absolute',
      zIndex: 1,
      animation: '$slide 1s',
      background:
        '-webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(255,255,255,0.8) 50%,rgba(128,186,232,0) 99%,rgba(125,185,232,0) 100%)' /* Chrome10+,Safari5.1+ */,
    },
  },
  '@keyframes slide': {
    from: {
      transform: 'translateX(-100%)',
    },
    to: {
      transform: 'translateX(100%)',
    },
  },
}));

export default useStyles;
